import list from './list';
import create from './create';
import update from './update';
import show from './show';

export default {
  namespaced: true,
  modules: {
    list,
    create,
    update,
    show
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoicetaxtype/index.js